class TriggerInfo {
  ADI = { id: 0, triggercode: '', name: '',  description: '' , title: ''}
  ALD = { id: 0, triggercode: '', name: '',  description: '' , title: ''}
  ALT = { id: 0, triggercode: '', name: '',  description: '' , title: ''}
  ATM = { id: 0, triggercode: '', name: '',  description: '' , title: ''}
  ATS = { id: 0, triggercode: '', name: '',  description: '' , title: ''}
  MAN = { id: 0, triggercode: '', name: '',  description: '' , title: ''}
  VFR = { id: 0, triggercode: '', name: '',  description: '' , title: ''}
  VLT = { id: 0, triggercode: '', name: '',  description: '' , title: ''}
  VLV = { id: 0, triggercode: '', name: '',  description: '' , title: ''}
  VMT = { id: 0, triggercode: '', name: '',  description: '' , title: ''}
  VMD = { id: 0, triggercode: '', name: '',  description: '' , title: ''}
  AMH = { id: 0, triggercode: '', name: '',  description: '' , title: ''}
  VMH = { id: 0, triggercode: '', name: '',  description: '' , title: ''}
  VMW = { id: 0, triggercode: '', name: '',  description: '' , title: ''}
  VMW_RTA = { id: 0, triggercode: '', name: '',  description: '' , title: ''}
  ASW_RTA = { id: 0, triggercode: '', name: '',  description: '' , title: ''}
  RFG = { id: 0, triggercode: '', name: '',  description: '' , title: ''}
  RFI = { id: 0, triggercode: '', name: '',  description: '' , title: ''}
  RSG = { id: 0, triggercode: '', name: '',  description: '' , title: ''}

  constructor(triggersInfo = []){
    triggersInfo.forEach(t => {
      this[t.triggercode] = {...t, title: this.title(t)}
    })
  }
  title(obj={}){
    return `${obj.triggercode}: ${obj.name}`}
}

export default TriggerInfo
